export const quizAnswerLabels = {
    timeAllocation: {
        operational_work: "Haciendo trabajo operativo",
        supervising_problems: "Supervisando y resolviendo problemas",
        leading_team: "Dirigiendo al equipo y revisando resultados",
        strategy_growth_talent: "En estrategia, crecimiento y talento"
    },
    dailyDependence: {
        owner_personally: "Hago casi todo personalmente",
        owner_approval: "Tengo equipo, pero casi todo requiere mi aprobación",
        team_needs_frequently: "Mi equipo opera, pero aún me necesita con frecuencia",
        team_independent_growth: "Mi equipo opera sin depender de mí; yo me enfoco en crecer"
    },
    operatingKnowledge: {
        owner_head: "Principalmente en mi cabeza",
        people_and_isolated_documents: "En personas y documentos aislados",
        documented_processes: "En procesos documentados que se siguen",
        measured_continuously_improved: "En procesos medidos y mejorados continuamente"
    },
    dailyDecisions: {
        owner_most: "Casi todas pasan por mí",
        owner_approval_many: "Muchas todavía requieren mi aprobación",
        area_responsibles: "Los responsables deciden dentro de sus áreas",
        leaders_autonomous: "Los líderes deciden con autonomía"
    },
    problemHandling: {
        owner_solves: "Termino resolviéndolo yo",
        owner_intervenes: "Debo intervenir o indicar qué hacer",
        responsible_with_support: "El responsable suele resolverlo con algo de apoyo",
        team_independent: "El equipo lo resuelve sin depender de mí"
    },
    priorityManagement: {
        daily_urgencies: "Según las urgencias del día",
        too_many_shifting: "Tenemos demasiadas y cambiamos de enfoque",
        few_tracked: "Tenemos pocas prioridades y les damos seguimiento",
        clear_measured_protected: "Están claras, medidas y protegidas"
    },
    resultAccountability: {
        confusion_owner_gaps: "Hay confusión y termino cubriendo vacíos",
        responsibles_need_followup: "Hay responsables, pero requieren seguimiento constante",
        area_responsibles_clear: "Cada área tiene responsables y resultados claros",
        leaders_autonomous_results: "Los líderes responden por resultados con autonomía"
    },
    resultsTracking: {
        problem_reactive: "Revisamos cuando aparece un problema",
        irregular: "El seguimiento es irregular",
        regular_review: "Revisamos resultados regularmente",
        kpis_fast_decisions: "Usamos KPIs para detectar problemas y decidir rápido"
    },
    decisionDelegation: {
        hard_to_delegate: "Me cuesta delegarlas",
        tasks_only: "Delego tareas, pero las decisiones regresan a mí",
        within_clear_limits: "Delego decisiones dentro de límites claros",
        leaders_decide_develop: "Los líderes deciden y desarrollan a otros líderes"
    },
    strategyTime: {
        almost_none: "Casi nada",
        only_when_urgent: "Solo cuando disminuyen las urgencias",
        regularly_reserved: "Reservo tiempo regularmente",
        agenda_priority: "Es una prioridad de mi agenda"
    },
    growthCapacity: {
        operation_collapses: "La operación probablemente colapsaría",
        team_saturates: "El equipo y yo nos saturaríamos",
        manageable_with_adjustments: "Podríamos manejarlo con algunos ajustes",
        leaders_and_systems_absorb: "Nuestros líderes y sistemas absorberían gran parte del crecimiento"
    },
    technologyIntegration: {
        mostly_manual: "La mayoría del trabajo sigue siendo manual",
        disconnected_tools: "Tenemos herramientas, pero están desconectadas",
        systems_and_automations: "Usamos sistemas y automatizaciones que mejoran la operación",
        integrated_for_scaling: "Están integrados en procesos clave y ayudan a escalar"
    },
    annualRevenue: {
        no_business: "No tengo negocio",
        under_100k: "Menos de $100,000 USD.",
        "100k_500k": "$100,000 – $500,000 USD",
        "500k_1m": "$500,000 – $1M USD",
        "1m_5m": "$1M – $5M USD",
        over_5m: "Más de $5M USD"
    },
    teamSize: {
        solo: "Solo yo",
        "2_5": "2-5 personas",
        "6_15": "6-15 personas",
        "16_30": "16-30 personas",
        "30_plus": "30+ personas"
    }
};
